import * as React from 'react';

import { getLanguageCode } from '../../shared/helpers';

interface ListResultsProps {
  items: Object[];
}

const ListResults = ({ items }: ListResultsProps): JSX.Element => (
  <ul className="list__results">
    {items.map((item: any, index: number): JSX.Element => {
      const value = typeof item.value === 'number' ? item.value.toLocaleString(getLanguageCode()) : item.value;

      return (
        <li key={index} className="list__results-item">
          <span className="list__results-label"> {item.label} </span>
          <span className="list__results-value"> {value} </span>
        </li>
      );
    })}
  </ul>
);

export default ListResults;
